import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

const StatusFilter = ({ selectedStatus, onChange, installations = [] }) => {
  // Calculate counts for each status
  const statusCounts = installations.reduce((acc, inst) => {
    acc[inst.status] = (acc[inst.status] || 0) + 1;
    return acc;
  }, {});

  // Create menu items only for statuses that have installations
  const getStatusMenuItems = () => {
    const items = [];
    
    // Add specific statuses only if they have installations
    Object.entries(statusCounts).forEach(([status, count]) => {
      items.push(
        <MenuItem key={status} value={status}>
          <Typography>
            {status} ({count})
          </Typography>
        </MenuItem>
      );
    });

    // Always add "All Statuses" with total count
    const totalCount = installations.length;
    items.push(
      <MenuItem key="all" value="">
        <Typography>
          All Statuses ({totalCount})
        </Typography>
      </MenuItem>
    );

    return items;
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="status-filter-label">Status</InputLabel>
      <Select
        labelId="status-filter-label"
        id="status-filter"
        value={selectedStatus}
        label="Status"
        onChange={(e) => onChange(e.target.value)}
      >
        {getStatusMenuItems()}
      </Select>
    </FormControl>
  );
};

export default StatusFilter;
